'use strict'

import axios from 'axios'
import store from '@/store'
import Vue from 'vue'
import Configuration from '@/agilis/util/Configuration'

// Full config:  https://github.com/axios/axios#request-config

let config = {
  baseURL: window.envmap.VUE_APP_AGILIS_CONFIGURATOR_ENDPOINT
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

// agilis REST API utilitites

// user profile
_axios.agilisUrlUserProfile = function (userId) { return `/api/agilis/user/${userId}/profile` }

// configuration
_axios.agilisUrlConfiguration = function () { return `/api/agilis/configuration` }
_axios.agilisUrlConfigurationMinified = function () { return `/api/agilis/configuration/minified` }
_axios.agilisUrlConfigurationPart = function (appId, documentPartId) { return `/api/${appId}/configuration/part/${documentPartId}` }
_axios.agilisUrlConfigurationPartSave = function (appId, documentPartId, version) { return `/api/${appId}/configuration/part/${documentPartId}/version/${version}` }
_axios.agilisUrlConfigurationForApplication = function (appId) { return `/api/${appId}/configuration/` }

// tag
_axios.agilisUrlTags = function (appId, trackerTypeId, tagTypeId) { return `/api/${appId}/tracker/${trackerTypeId}/tags/${tagTypeId}` }
_axios.agilisUrlTagDelete = function (appId, trackerTypeId, tagTypeId, tagId) { return `/api/${appId}/tracker/${trackerTypeId}/tags/${tagTypeId}/${tagId}` }

// entity
_axios.agilisUrlNestedEntity = function (appId, trackerTypeId, trackerId, entity) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/${entity}` }
_axios.agilisUrlNestedEntityEdit = function (appId, trackerTypeId, trackerId, entity, entityId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/${entity}/${entityId}` }

// tracker
_axios.agilisUrlTracker = function (appId, trackerTypeId) { return `/api/${appId}/tracker/${trackerTypeId}` }
_axios.agilisUrlTrackerAction = function (appId, trackerTypeId, trackerId, eventId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/event/${eventId}` }
_axios.agilisUrlTrackerAttachments = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/attachments` }
_axios.agilisUrlTrackerAttachmentsV2 = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/attachmentsV2` }
_axios.agilisUrlTrackerAssociations = function (appId, trackerTypeId, trackerId) { return _axios.urlOverride('/api/$0/tracker/$1/$2/associationsV2', appId, trackerTypeId, trackerId) }
_axios.agilisUrlTrackerAssociationsDelete = function (appId, trackerTypeId, trackerId, associationsId) { return _axios.urlOverride(`/api/$0/tracker/$1/$2/associationsV2/$3`, appId, trackerTypeId, trackerId, associationsId) }
_axios.agilisUrlTrackerAttachmentsEdit = function (appId, trackerTypeId, trackerId, attachmentId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/attachments/${attachmentId}` }
_axios.agilisUrlTrackerAttachmentsV2Edit = function (appId, trackerTypeId, trackerId, attachmentId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/attachmentsV2/${attachmentId}` }
_axios.agilisUrlTrackerAuthors = function (appId, trackerTypeId) { return `/api/${appId}/tracker/${trackerTypeId}/authors` }
_axios.agilisUrlTrackerChildren = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/children` }
_axios.agilisUrlTrackerCopy = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/copy` }
_axios.agilisUrlTrackerCollaborators = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/collaborator` }
_axios.agilisUrlTrackerCollaboratorsDelete = function (appId, trackerTypeId, trackerId, collaboratorId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/collaborator/${collaboratorId}` }
_axios.agilisUrlTrackerCollaboratorsOverride = function (appId, trackerTypeId) { return _axios.urlOverride('/api/$0/tracker/$1/collaborators', appId, trackerTypeId) }
_axios.agilisUrlTrackerEdit = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}` }
_axios.agilisUrlTrackerHistory = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/history` }
_axios.agilisUrlTrackerNote = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/note` }
_axios.agilisUrlTrackerNoteEdit = function (appId, trackerTypeId, trackerId, noteId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/note/${noteId}` }
_axios.agilisUrlTrackerParents = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/parents` }
_axios.agilisUrlTrackerParentsSearch = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/parents/search` }
_axios.agilisUrlTrackerSearch = function (appId, trackerTypeId) { return `/api/${appId}/tracker/${trackerTypeId}/search` }
_axios.agilisUrlTrackerStatusCheck = function (appId, trackerTypeId, statusCheckId) { return `/api/${appId}/tracker/${trackerTypeId}/statusCheck/${statusCheckId}` }
_axios.agilisUrlTrackerTemplateAttachments = function (appId, trackerTypeId, trackerId) { return `/api/${appId}/tracker/${trackerTypeId}/${trackerId}/attachmentTemplates` }
_axios.agilisUrlTrackerPushNotification = function (userId) { return `/apiws/notification/${userId}` }

// datatable
_axios.agilisUrlDataTable = function (api) { return api }
_axios.agilisUrlDataTableEdit = function (api, itemId) { return `${api}/${itemId}` }
_axios.agilisUrlDataTableSearch = function (api) { return `${api}/search` }

// query
_axios.agilisUrlQuery = function (applicationId, query) { return `/api/${applicationId}/query/${query}` }
_axios.agilisUrlQueryTrackerType = function (applicationId, trackerTypeId, query) { return `/api/${applicationId}/tracker/${trackerTypeId}/query/${query}` }

// document
_axios.agilisUrlDocument = function (appId, documentId) { return `/api/${appId}/document/${documentId}` }
_axios.agilisUrlDocumentCheckin = function (appId, documentId) { return `/api/${appId}/document/${documentId}/checkin` }
_axios.agilisUrlDocumentCheckout = function (appId, documentId) { return `/api/${appId}/document/${documentId}/checkout` }

// third party services
_axios.agilisUrlHubspotCompany = function (companyId) { return `/api/service/hubspot/company/${companyId}` }
_axios.agilisUrlHubspotCompanySearch = function () { return `/api/service/hubspot/company/search` }
_axios.agilisUrlSupersetChart = function (chartId, format, type) { return `/api/service/superset/chart/${chartId}/data?format=${format}&type=${type}` }
_axios.agilisUrlRocketChat = function () { return `/api/service/chat/rocketchat/createDiscussionWithUsers` }

_axios.agilisUrlAddContext = function (url, selectedContext) {
  url = url.replace('$applicationId', selectedContext.applicationId)
  url = url.replace('$trackerTypeId', selectedContext.trackerTypeId)
  url = url.replace('$trackerId', selectedContext.trackerId)
  return url
}

_axios.agilisRequestConfig = function (url, forceBaseURL = null, {
  applicationId,
  workspaceId
} = {}) {
  let requestConfig = {}

  const selectedContext = store.state.contextStore.selectedContext

  const requestContext = {
    ...selectedContext,

    // Let override part of the context
    applicationId: applicationId || selectedContext.applicationId,
    workspaceId: workspaceId || selectedContext.workspaceId
  }

  // Agilis-Request-Context header
  let agilisHeaderContext = {
    userInfo: {
      language: store.getters['userDataStore/userLanguage']
    },
    selectedContext: requestContext
  }
  requestConfig.headers = { 'Agilis-Request-Context': JSON.stringify(agilisHeaderContext) }

  // Authorization header
  const token = Vue.prototype.$keycloak != null ? Vue.prototype.$keycloak.token : undefined
  if (token != null) {
    requestConfig.headers['Authorization'] = `Bearer ${token}`
  }

  // request endpoint
  if (forceBaseURL != null) {
    requestConfig.baseURL = forceBaseURL
  } else {
    // resolve application base url, default available only in local
    requestConfig.baseURL = window.envmap.VUE_APP_AGILIS_APP_DEFAULT_ENDPOINT

    if (!requestConfig.baseURL) {
      if (store.getters['contextStore/baseURL']) { // check current tracker context
        requestConfig.baseURL = store.getters['contextStore/baseURL']
      } else { // check in app config
        const appConfig = Configuration.getApplication(requestContext.applicationId)
        requestConfig.baseURL = appConfig && appConfig.baseURL
      }
    }
  }

  return requestConfig
}

// compute api request and params
// default api request method is GET.
// update apiMethod with the correct api request method
_axios.agilisComputeApiProp = function (fieldConfig, apiMethod = 'GET') {
  let api = {}
  const {
    url,
    body = {},
    method = apiMethod,
    path = null,
    context = {}
  } = fieldConfig?.api || { url: fieldConfig?.url }

  api.url = url
  api.body = body
  api.method = method.toLowerCase()
  api.path = path
  api.context = context
  api.config = _axios.agilisRequestConfig(api.url, null, api.context)

  return api
}

// apply api ovverides from application configuration
//
// apiOverrides: [
//    {url:"/api/$0/tracker/$1/$2/associations", override:"/api/$0/tracker/$1/$2/associationsV2"}
// ]
_axios.urlOverride = function (url, ...ids) {
  let computedUrl = url
  if (ids.length > 0) {
    // first argument should be appId
    const appConfig = Configuration.getApplication(ids[0])
    if (appConfig?.apiOverrides) {
      const overrideConfig = appConfig.apiOverrides.find(elem => elem.url === url)
      if (overrideConfig) {
        computedUrl = overrideConfig.override
      }
    }
    for (let i = 0; i < ids.length; i++) {
      computedUrl = computedUrl.replace('$' + i, ids[i])
    }
  }
  return computedUrl
}

Plugin.install = function (Vue/*, options */) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
